<ion-content>
  @if (purchaseDetail$ | async; as purchaseDetail) {
    <div class="store-payment-wrapper">
      @if (stepperIndex == 0) {
        <div class="store-payment-top">
          <img src="assets/icon/back_arrow.png" alt="Back arrow" class="back-ic" (click)="handleExitIntentPopup()" />
          <h1 class="checkout-heading">{{ "add-card.Checkout" | translate }}</h1>
        </div>
      }
      @if (stepperIndex == 1) {
        <div class="store-summary-top">
          <h1 class="checkout-heading">{{ "add-card.confimation" | translate }}</h1>
        </div>
      }
      <mat-horizontal-stepper labelPosition="bottom" [selectedIndex]="stepperIndex" #stepper
        class="payment-stepper store-checkout-payment" [linear]="true">
        <mat-step [completed]="isPaymentDone">
          <ng-template matStepLabel>{{ "add-card.Payment" | translate }}</ng-template>
          <div class="wallet-type">
            @if (purchaseDetail?.page === 'topUp') {
              <div>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ "add-card.Top up" | translate }}</p>
                  <p class="purchase-content">{{ purchaseDetail?.real_name }}</p>
                  @if (purchaseDetail?.line) {
                    <p class="purchase-content">
                      {{ purchaseDetail?.line }} {{ "add-card.Line(s)" | translate }}
                    </p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'store') {
              <div>
                <ion-card class="purchase-card">
                  @if (!checkout_description) {
                    <p class="purchase-heading">{{ purchaseDetail?.selectedDay?.length * (purchaseDetail?.line + 1) }} {{
                      "store-payment.Lines" | translate }}, {{ ('dynamic_value.'+ purchaseDetail?.real_name) | translate }}
                    </p>
                  }
                  <ng-container>
                    <p class="purchase-content">
                      @if (checkout_description) {
                        <p [innerHTML]="checkout_description | safeHtml | translate"></p>
                      } @else {
                        {{ purchaseDetail?.line + 1 }} {{ (purchaseDetail?.line > 1 ? "store-payment.Lines" :
                        "store-payment.line") |
                        translate }} {{ ('dynamic_value.'+ purchaseDetail?.real_name) | translate }}
                        @for (day of purchaseDetail?.selectedDay; track day; let i = $index) {
                          <span>
                            @if (i > 0) {
                              <span>, </span>
                            }
                            {{ ('dynamic_value.'+(day | day) | translate) }}
                          </span>
                        }
                        @if (customOfferCashbackText) {
                          <span>{{' + ' + customOfferCashbackText}}</span>
                        }
                      }
                    </p>
                  </ng-container>
                  @if (purchaseDetail?.selectedDay?.length > 0 && purchaseDetail?.selectedDiscount?.type === 'subscription') {
                    <p class="purchase-content"
                      >
                      {{ "store-payment.flexible_membership" | translate }}
                    </p>
                  }
                  @if (purchaseDetail?.selectedDay?.length > 0 && purchaseDetail?.selectedDiscount?.type === 'oneoff') {
                    <p class="purchase-content"
                      >
                      {{ purchaseDetail?.selectedDiscount?._title?.[selectedLanguage || "en"] ||
                      purchaseDetail?.selectedDiscount?.title }}
                    </p>
                  }
                  @if (purchaseDetail?.offers?.no_weeks > 1 && purchaseDetail?.offers?.no_weeks < 100) {
                    <p class="purchase-content"
                      >
                      {{ "add-card.For" | translate }}{{ ' ' + purchaseDetail?.offers?.no_weeks }}
                      {{ "add-card.weeks" | translate }}
                    </p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'offerDay') {
              <div>
                <h1 class="purchase-title">{{ "add-card.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
                  @for (desc of purchaseDetail?.offers?.description; track desc) {
                    <p class="purchase-content">{{ desc }}</p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'offerOfDay' && purchaseDetail?.offers?.description?.length > 0) {
              <div>
                <h1 class="purchase-title">{{ "store-payment.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
                  @for (desc of purchaseDetail?.offers?.description; track desc) {
                    <p class="purchase-content" [innerHTML]="desc | safeHtml"></p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'syndicate') {
              <div>
                <h1 class="purchase-title">{{ "add-card.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
                  @for (product of purchaseDetail?.products; track product) {
                    <p class="purchase-content">
                      {{ product?.product_name }} {{ product?.line_count }} {{ "add-card.Line(s)" | translate }}
                    </p>
                  }
                  @for (selectedOffer of purchaseDetail?.selectedOffers; track selectedOffer) {
                    <p class="purchase-heading purchase-offer">{{ selectedOffer?.title }}</p>
                    <p class="purchase-content">{{ selectedOffer?.extract }}</p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'voucher') {
              <div>
                <h1 class="purchase-title">{{ "add-card.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
                  <p class="purchase-content">{{ purchaseDetail?.offers.description }}</p>
                </ion-card>
              </div>
            }
          </div>
          <!-- [UI] Update Addons Section start -->
          @if (upsellList && purchaseDetail?.offers?.p_type === 21) {
            <div class="upsell-container">
              <h4>{{ "payment.addons-title" | translate }} </h4>
              @for (addOnList of upsellList; track addOnList; let i = $index) {
                <ion-row class="splitter-line-bottom">
                  <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="checkbox-area">
                    <ion-checkbox mode="ios" color="secondary" [value]="addOnList?.price[preferredCurrency]"
                      (ionChange)="checkBoxChanged($event, addOnList)" [(ngModel)]="addOnList.isChecked">
                    </ion-checkbox>
                  </ion-col>
                  <ion-col size="8" size-md="10" size-lg="10" size-xl="10" class="details"
                    [innerHTML]="addOnList?.html_msg[selectedLanguage] | safeHtml">
                  </ion-col>
                  <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="price">
                    <strong> {{currencySymbol}}{{addOnList?.price[preferredCurrency]}} </strong>
                  </ion-col>
                </ion-row>
              }
            </div>
          }
          <!-- [UI] Update Addons Section end -->
          <!-- [UI] vouchers slider -->
          @if (discountVouchersStatus && discountVouchersData && (discountVouchersData?.length > 0) && !cardTokenizedCalled && !paymentFailRedirectionStatus) {
            <div class="vouchers-slider-wrapper">
              <h3 class="block-title">{{ "store-payment.Available_vouchers" | translate }}</h3>
              <swiper [config]="storeSliderOptions1">
                @for (voucher of discountVouchersData; track voucher) {
                <ng-template swiperSlide>
                  <div class="vouchers-slide" [class.used-voucher]="voucher.isUsed"
                    [class.voucher-slide-full]="voucher?.isSelected === false">
                    <span class="sub-title">-{{ voucher.discount_percentage }}% {{ voucher?.supplier?.toLowerCase() !== "general" ?
                      voucher?.supplier?.toUpperCase() : "" }}</span>
                    <p class="amount">{{ voucher?.changeExpiryText ? ("store-payment.Expires" | translate) :
                      ("store-payment.Expires_in" | translate) }} <app-count-down-timer class="remaining-time"
                        end="{{voucher?.expiry_date?.seconds}}" type="seconds"></app-count-down-timer>
                    </p>
                    <ion-checkbox mode="ios" class="voucher-checkbox" role="checkbox" [(ngModel)]="voucher.isSelected"
                      (ionChange)="onVoucherSelect($event, voucher)" [disabled]="voucher.isDisabled" labelPlacement="end"
                      [attr.data-applied-text]="'store-payment.applied' | translate"></ion-checkbox>
                      <div class="voucher_hand_tap">
                        @if(!isChecked()) {
                        <ng-lottie  class="hand_tap_animation" [options]="{ path : '../../../../assets/tap-animation.json' }"></ng-lottie>
                        }
                      </div>
                    </div>
                </ng-template>
                }
              </swiper>
            </div>
        }
        <!-- [UI] vouchers slider -->
        <div [innerHTML]="showVisaInfoHTML"></div>
        <div class="payable-today-wrapper">
          <p class="payable-today">{{ "add-card.Payable today" | translate }}</p>
          @if (purchaseDetail?.selectedDiscount) {
            <div>
              @if (purchaseDetail?.selectedDiscount?.type !== 'subscription') {
                <p class="payable-today-amt">
                  <span [ngClass]="{'strikethrough-grayed': selectedDiscountValue > 0}"> {{ currencySymbol }}{{ (purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize + (updatedPrizeValue || 0)) | displayCurrency }}</span> 
                  @if (selectedDiscountValue > 0) {
                  <span>{{ currencySymbol }}{{
                    ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize +
                    (updatedPrizeValue || 0)) - ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency]
                    : purchaseDetail?.prize + (updatedPrizeValue || 0)) *
                    selectedDiscountValue)) | displayCurrency }}
                </span>
                }
              </p>
            }
            @if (purchaseDetail?.selectedDiscount?.type == 'subscription') {
              <p class="payable-today-amt">
                {{ currencySymbol }}{{ ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize + (updatedPrizeValue || 0)) - ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize + (updatedPrizeValue || 0)) *  selectedDiscountValue)) | displayCurrency }}/wk
              </p>
            }
          </div>
        } @else {
          <div>
            @if (purchaseDetail?.page !== 'offerOfDay') {
              <p class="payable-today-amt">
                {{ currencySymbol }}{{ ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize + (updatedPrizeValue || 0)) - ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize + (updatedPrizeValue || 0)) *  selectedDiscountValue)) | displayCurrency }}
              </p>
            }
            @if (purchaseDetail?.page === 'offerOfDay') {
              <p class="payable-today-amt">
                {{ currencySymbol }}{{ ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize + (updatedPrizeValue || 0)) - ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize + (updatedPrizeValue || 0)) *  selectedDiscountValue)) | displayCurrency }}/wk
              </p>
            }
          </div>
        }
      </div>
      <!-- <div style="text-align: center; display: flow-root">
      <ion-icon style="color: green; margin-right: 1vh" name="lock-closed"></ion-icon>
      <span>{{ "add-card.Secure" | translate }}</span>
    </div> -->
    <!-- <div class="d-flex">
    <img src="../../../assets/icon/lock key.png" alt="" class="lock" />
    <p>Secure payment</p>
  </div> -->
  @if (isPaymill) {
<div style="
            padding: 0.3vh;
            border-radius: 2vh;
            min-height: 25vh;
            width: 97%;
            margin-left: 1.5%;
            margin-top: 1vh;
            height: auto;
          ">
      <div class="timer">
        <div class="d-flex">
          <img src="../../../assets/icon/lock key.png" alt="" class="lock" />
          <p>{{ "add-card.Secure" | translate }}</p>
        </div>
        <div>{{ "add-card.time_left" | translate }}: <span #timer></span></div>
      </div>
      <div style="visibility: hidden" [ngClass]="isPaymentDone ? 'show' : 'hide'">
        @defer () {
        <iframe style="border: 0; width: 100%; height: 100vh; padding: 1vh" #iframe id="myCustomIframe1"
          name="myCustomIframe1" (load)="load(iframe, stepper)"
          sandbox="allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation">
        </iframe>
      }
    </div>
    @if (!isPaymentDone) {
      <div>
        <div style="position: absolute; width: 92%; text-align: center">
          @if (addNewCardInProgress) {
            <ion-spinner name="lines-small" diameter="40"
              style="color: green; margin-top: 4vh">
            </ion-spinner>
          }
        </div>
        <form action="{{ origin + '/r' }}" class="paymentWidgets" data-brands="VISA MASTER"></form>
      </div>
    }
  </div>
}
@if (isCheckoutCom) {
<div style="
            padding: 0.3vh;
            border-radius: 2vh;
            min-height: 25vh;
            width: 97%;
            margin-left: 1.5%;
            margin-top: 1vh;
            height: auto;
            position: relative;
            background-color: transparent;
          " class="checkout_gateway">
    <form id="payment-form" [hidden]="!isCheckoutComform" (submit)="onSubmit($event)">
      <ng-container>
        <div class="one-liner flow-entry">
          <div id="cko-flow-container" class="cko-flow-container"></div>
        </div>
        @if (errorMessage) {
          <div class="message">
            @if (isCheckoutLoadingMessage(errorMessage) && showCheckOutComSpinner && !checkoutFlowReady) {
              <ion-spinner name="lines-small" class="checkout-inline-spinner"></ion-spinner>
            }
            <p [ngClass]="isCheckoutLoadingMessage(errorMessage) ? 'loading-message' : 'error-message'">{{ errorMessage }}</p>
          </div>
        }
      </ng-container>
    </form>
    @defer (when redirectlink) {
    <iframe
        [ngStyle]="{ 'height': isCheckoutComform ? '0vh' : '100vh', 'pointer-events': isCheckoutComform ? 'none' : 'auto', 'min-height': isCheckoutComform ? '0' : null }"
        style="border: 0; width: 100%; padding: 1vh;"
        id="checkoutAuthorizationIframe"
        name="checkoutAuthorizationIframe"
        [src]="redirectlink"
        #checkOutIframe>
    </iframe>
  }
</div>
}
<p class="text-button" (click)="handleExitIntentPopup()">{{ "payment.No" | translate }}</p>
<p class="disclaimer-text">
  {{'payment.Hatchster'|translate}}
</p>
<!-- <p class="bottom-info">
{{ "add-card.Hatchster" | translate }}
</p> -->
</mat-step>
<mat-step>
  <ng-template matStepLabel> {{ "add-card.Summary" | translate }}</ng-template>
  <div class="checkout-summary">
    <ion-card class="brought-card">
      <p class="brought-card-heading">{{ "add-card.bought" | translate }}</p>
      <div class="brought-card-content-wrap">
        @if (purchaseDetail?.page === 'topUp') {
          <p class="brought-card-title">
            {{ "add-card.Top up" | translate }}
          </p>
        }
        @if (purchaseDetail?.page != 'topUp' && !checkout_description) {
          <p class="brought-card-title">
            {{ purchaseDetail?.real_name }} {{'add-card.Lines'|translate}}
          </p>
        }
        @if (purchaseDetail?.page === 'topUp' && purchaseDetail?.page !== 'syndicate') {
          <p class="brought-card-content"
            >
            {{ purchaseDetail?.real_name }}
          </p>
        }
        @if (purchaseDetail?.page === 'syndicate') {
          <div>
            <p class="brought-card-content">{{ purchaseDetail?.real_name }}</p>
            @for (product of purchaseDetail?.products; track product) {
              <p class="line-heading">{{ product?.product_name }}</p>
              <p class="line-total">{{ product?.line_count }}{{'add-card.Line(s)'|translate}}</p>
            }
            @for (selectedOffer of purchaseDetail?.selectedOffers; track selectedOffer) {
              <p class="line-heading">{{ selectedOffer?.title }}</p>
              <p class="line-content">{{ selectedOffer?.extract }}</p>
            }
          </div>
        }
        @if (purchaseDetail?.page === 'offerDay') {
          <div>
            @for (desc of purchaseDetail?.offers?.description; track desc) {
              <p class="lines-total offerDay-desc">{{ desc }}</p>
            }
          </div>
        }
        @if (purchaseDetail?.page === 'store') {
          <div>
            @if (checkout_description) {
              <p [innerHTML]="checkout_description | safeHtml | translate"></p>
            } @else {
              @for (day of purchaseDetail?.selectedDay; track day) {
                <p class="lines-total offerDay-desc">{{ purchaseDetail?.line + 1 }} {{'add-card.lines on'|translate}}
                  {{ ('dynamic_value.'+(day | day) | translate) }} @if (customOfferCashbackText) {
                  <span>{{' + ' +
                  customOfferCashbackText}}</span>
                } </p>
              }
            }
          </div>
        }
        @if (purchaseDetail?.page === 'voucher') {
          <div>
            <p class="line-content">{{ purchaseDetail?.offers.description }}</p>
          </div>
        }
        @if (purchaseDetail?.page === 'topUp') {
          <div></div>
        }
        <!-- UI for showing upsell options summary -->
        @if (upsellSummaryArray && upsellSummaryArray.length > 0) {
          <div class="upsell-checkout-summary">
            @for (addOn of upsellSummaryArray; track addOn) {
              @if (addOn.product_description === 'award' && addOn?.summary_content) {
                <div>
                  <p class="brought-card-title">
                    {{ "add-card.Top up" | translate }}
                  </p>
                  <p class="brought-card-content">
                    {{ currencySymbol + addOn.summary_content?.amount?.[preferredCurrency] + ' ' +
                    addOn.summary_content?.real_name + ' ' + addOn?.summary_content?.sub_label?.[selectedLanguage] }}
                  </p>
                </div>
              }
              @if (addOn.product_description === 'offer' && addOn?.summary_content) {
                <div>
                  <p class="brought-card-title">
                    {{ addOn.summary_content?.real_name }} {{'add-card.Lines'|translate}}
                  </p>
                  @for (day of addOn.summary_content?.selected_day; track day) {
                    <p class="lines-total offerDay-desc">{{ addOn.summary_content?.line + 1 }} {{'add-card.lines
                      on'|translate}}
                      {{ ('dynamic_value.'+(day | day) | translate) }}
                    </p>
                  }
                </div>
              }
            }
          </div>
        }
        <ion-row class="card-price-wrap">
          <ion-col>
            <p class="card-price">{{ "add-card.Price" | translate }}</p>
          </ion-col>
          <ion-col class="card-price-value-wrap">
            @if (purchaseDetail?.selectedDiscount) {
              <div>
                @if (purchaseDetail?.selectedDiscount?.type !== 'subscription') {
                  <p class="card-price-value">
                    <span [ngClass]="{'strikethrough-grayed': selectedDiscountValue > 0}"> {{ currencySymbol }}{{ (purchaseDetail?.prize +
                    (updatedPrizeValue || 0)) | displayCurrency }}</span> @if (selectedDiscountValue > 0) {
                    <span>{{ currencySymbol }}{{
                      ((purchaseDetail?.prize + (updatedPrizeValue || 0)) - ((purchaseDetail?.prize + (updatedPrizeValue || 0)) *
                    selectedDiscountValue)) | displayCurrency }}</span>
                  }
                </p>
              }
              @if (purchaseDetail?.selectedDiscount?.type == 'subscription') {
                <p class="card-price-value">
                  {{ currencySymbol }}{{ (purchaseDetail?.prize + (updatedPrizeValue || 0)) | displayCurrency }}/wk
                </p>
              }
            </div>
          } @else {
            <div>
              @if (purchaseDetail?.page !== 'offerOfDay') {
                <p class="card-price-value">
                  {{ currencySymbol }}{{ (purchaseDetail?.prize + (updatedPrizeValue || 0)) | displayCurrency }}
                </p>
              }
              @if (purchaseDetail?.page === 'offerOfDay') {
                <p class="card-price-value">
                  {{ currencySymbol }}{{ (purchaseDetail?.prize + (updatedPrizeValue || 0)) | displayCurrency
                  }}/wk
                </p>
              }
            </div>
          }
        </ion-col>
      </ion-row>
    </div>
    @if (purchaseDetail?.draw) {
      <ion-row class="start-day-wrapper">
        <ion-col>
          <p class="start-date">{{ "add-card.Start date" | translate }}</p>
        </ion-col>
        <ion-col class="start-day-wrap">
          <p class="start-day">{{ ('dynamic_value.'+(purchaseDetail?.draw | day) | translate) }}</p>
        </ion-col>
      </ion-row>
    }
  </ion-card>
  <ion-button class="view-ticket-btn" (click)="fetchSyndicateAndShowTicket()" [disabled]="addNewCardInProgress">
    @if (addNewCardInProgress) {
      <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
      style="color: white; margin-right: 1vh"></ion-spinner>
    }
    @if (purchaseDetail.page == 'topUp' && !addNewCardInProgress) {
      <span>{{ "add-card.Back to store" |
        translate }}
      </span>
    }
    @if (purchaseDetail.page != 'topUp' && !addNewCardInProgress) {
      <span>{{
        "add-card.View ticket" | translate
      }}</span>
    }
  </ion-button>
</div>
</mat-step>
<ng-template matStepperIcon="edit">
  <mat-icon>{{'add-card.Done'|translate}}</mat-icon>
</ng-template>
</mat-horizontal-stepper>
@if (stepperIndex == 1) {
  <ion-row class="list-wrapper-background">
    <div class="jackpot-items">
      <ion-item lines="none" class="total-list-container">
        <ion-grid class="ion-no-padding splitter-line">
          <ion-row>
            <swiper class="store-slider-trigger" [config]="storeSliderOptions2" #slider
              (swiper)="setSwiperInstance($event)">
              @for (item of promotions; track item; let i = $index) {
                <ng-template swiperSlide>
                  <div class="jpt-banner" [ngClass]="{'card-gray':cardOfferDisabled(i)}"
                    [ngStyle]="{'background': item.background}">
                    <div class="overlay-2 single-overlay">
                      <div class="adjusted-column-sizes">
                        <div class="column-70">
                          <div class="card-title">
                            <h5>{{item.jackpot_value}}</h5>
                            <p [innerHTML]="item.content.description" class="card-desc"></p>
                          </div>
                          <ion-button class="card-cta"
                            (click)="!cardOfferDisabled(i) ? cardOfferPayment(item, i) : null"
                            [disabled]="cardOfferDisabled(i)">
                            <p [innerHTML]="item.content.cta_label"></p>
                          </ion-button>
                        </div>
                        <div class="column-40">
                          <p class="cardTimer">{{item.content.expiry_label}}<br>{{expiry_in_minutes}}:{{seconds}}</p>
                          <div class="image-wrapper">
                            <img alt="Lottery icon" src="{{item.image_url}}" />
                          </div>
                        </div>
                      </div>
                      <!-- Processing Indicator -->
                      @if (processingStates[i]) {
                        <div class="processing-overlay">
                          <div class="spinner"></div>
                          <p>Processing...</p>
                        </div>
                      }
                    </div>
                  </div>
                </ng-template>
              }
            </swiper>
            <ion-row class="my-custom-pager">
              <ion-col sizeSm="4" sizeLg="4" class="pager-2">
                <button (click)="prev()" class="nav-prev-icon-euro">
                  <ion-icon name="chevron-back-outline"></ion-icon>
                </button>
              </ion-col>
              <ion-col sizeSm="2" sizeLg="4" class="pager-2">
                <div class="swiper-pagination-2"></div>
              </ion-col>
              <ion-col sizeSm="4" sizeLg="4" class="pager-2">
                <button (click)="next()" class="nav-next-icon-euro">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </button>
              </ion-col>
            </ion-row>
          </ion-row>
        </ion-grid>
      </ion-item>
    </div>
  </ion-row>
}
</div>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}
</ion-content>

<ng-template #loading>
  <app-in-progress-animation></app-in-progress-animation>
</ng-template>
